import axios from 'axios';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import Dialog from 'vant/lib/dialog';
import 'vant/lib/dialog/style';
import store from '../store';
import router from '../router';
import CryptoJS from 'crypto-js'
import {compressToEncodedURIComponent,decompressFromEncodedURIComponent} from 'lz-string';

// 十六位十六进制数作为密钥
const SECRET_KEY = CryptoJS.enc.Utf8.parse('1234123412341234')
// 十六位十六进制数作为密钥偏移量
const SECRET_IV = CryptoJS.enc.Utf8.parse('1234123412341234')

/**
 * 加密方法
 * @param data - 数据
 */
export function encrypt(data) {
  const dataHex = CryptoJS.enc.Utf8.parse(data)
  const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}
/**
 * 解密方法
 * @param data - 数据
 */
export function decrypt(data) {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(data)
  const str = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}
export function LZStringCompress(string){
  return compressToEncodedURIComponent(string)
}
export function LZStringDecompress(string){
  return decompressFromEncodedURIComponent(string)
}

const urlEncode = function (param, key, encode) {
  if(!param) return '';
  var paramStr = '';
  var t = typeof (param);
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr += '&' + key + '=' + ((encode==null||encode) ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      paramStr += urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
};

/*
 * 隐藏loading toast
 * */
// const hideToastArr = [
//   'bubble/gain',
//   'user/config',
//   'user/index',
//   'bubble/gain_quick',
// ];

/*
 * axios 拦截器
 * */
axios.interceptors.request.use(function (config) {
  // console.log('axios: ', config);
  // console.log('store', store);

  // if (store.state.token && store.state.token !== '') {
  //   config.headers.token = store.state.token;
  // }
  // if (!config.data) config.data = {};
  // get 方法无data属性
  // let showToast = true;
  // for (let k in hideToastArr) {
  //   if (config.url.search(hideToastArr[k]) !== -1) {
  //     showToast = false
  //   }
  // }
  // if (showToast && config.method == 'post') {
  //   Toast({
  //     type: 'loading',
  //     closeOnClick: true,
  //     duration: 1000,
  //   })
  //   // config.data.uid = store.state.uid;
  // }
  return config
}, function (error) {
  return Promise.reject(error)
});

axios.interceptors.response.use(function (response) {
  if (response.data.code === undefined && response.data.data) {
    response.data = response.data.data
    response.data.code = parseInt(response.data.code)
  }

  if (!checkResponse(response)) {
    if (response.data) {
      // Toast(response.data.msg);
      if (response.data.code === 20013 || response.data.code === 20012) {
        logout();
        router.push('/login');
      }
    } else {
      // 返回消息格式错误
    }
  }
  return response
}, function () {

  // if (/401/.test(error)) {
  //   store.commit('setState', {
  //     noticeMsg: '身份过期，请重新登录',
  //     noticeType: 1
  //   })
  //   store.dispatch('maskShow');
  //   // window.localStorage.removeItem('token');
  //   // window.localStorage.removeItem('userId');
  // } else{
  //   store.commit('setState', {
  //     'noticeMsg': '网络繁忙，请稍后重试'
  //   })
  //   store.dispatch('maskShow')
  // }
});


const checkResponse = (response) => {
  if (!response || !response.data || response.data.code !== 0) {
    return false
  }
  return true
};

const logout = () => {
};


const GetRequestParam = (href) => {
  href = href ? href : window.location.href;
  var url = href.substr(href.indexOf("?")); //获取url中"?"符后的字串
  var theRequest = new Object();
  var strs = '';
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
};


/*
 * 根据时间戳获得时间格式，时间转换
 * */
const fmtDate = (timestamp = Date.parse(new Date()), type = 1) => {
  let date = new Date(timestamp);
  let y = 1900 + date.getYear();
  let m = '0' + (date.getMonth() + 1);
  let d = '0' + date.getDate();
  let h = '0' + date.getHours();
  let i = '0' + date.getMinutes();
  let s = '0' + date.getSeconds();
  let rs;
  switch (type) {
    case 1:
      rs = y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length) + ' ' + h.substring(h.length - 2, h.length) + ':' + i.substring(i.length - 2, i.length) + ':' + s.substring(s.length - 2, s.length);
      break;
    case 2:
      rs = y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length);
      break;
    default:
      rs = y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length) + ' ' + h.substring(h.length - 2, h.length) + ':' + i.substring(i.length - 2, i.length) + ':' + s.substring(s.length - 2, s.length);
      break;
  }
  return rs;
};

const checkPhoneNumberNew = (phone) => {
  // /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|19[0-9]|16[0-9])[0-9]{8}$/
  return /^1[3-9][0-9]\d{8}$/.test(phone);
};

//千位符展示
const showTotalData=(data)=> {
  // return (dataS || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  return (data || 0).toString().replace(/\d(?=(?:\d{3})+\b)/g, '$&,');

}
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //不含最大值，含最小值
};

const cutPhone = (phone) => {
  // return phone.substr(0, 3) + '...' + phone.substr(7, 11);
  return phone.substr(0, 3) + '..' + phone.substr(phone.length - 1, phone.length - 1);
};

const cutPhone1 = (phone) => {
  // return phone.substr(0, 3) + '...' + phone.substr(7, 11);
  return phone.substr(0, 8) + '..' + phone.substr(phone.length - 5, phone.length - 1);
};

const isiOS = () => {
  const u = navigator.userAgent;
  // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
};
//js字符串截取  省略号
function Cutsubstr(str, len) {
  if (!str || !len) { return ''; }
  var build = "";
  for (var i = 0; i < str.length && len > 0; i++) {
    build += str.substr(i, 1);
    len -= str.charCodeAt(i) > 127 ? 2 : 1;
  }
  if (build.length < str.length)
    build += "...";
  return build;
}
//保留小数的方法 只舍不入
const done = (num, digits) => {
  // num = num / 1000 * 2
  const multiple = Math.pow(10, digits)
  return parseFloat(Math.floor(num * multiple) / multiple)
}

function fmDate(time) {//时间戳转日期
  let date = new Date(time);
  let y = date.getFullYear();
  let MM = (date.getMonth() + 1).toString();
  MM = parseInt(MM) < 10 ? ('0' + MM) : MM;
  let d = date.getDate().toString();
  d = parseInt(d) < 10 ? ('0' + d) : d;
  let h = date.getHours().toString();
  h = parseInt(h) < 10 ? ('0' + h) : h;
  let m = date.getMinutes().toString();
  m = parseInt(m) < 10 ? ('0' + m) : m;
  let s = date.getSeconds().toString();
  s = parseInt(s) < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

export function fmDate1(time) {//时间戳转日期
  let date = new Date(time);
  let y = date.getFullYear();
  let MM = (date.getMonth() + 1).toString();
  MM = parseInt(MM) < 10 ? ('0' + MM) : MM;
  let d = date.getDate().toString();
  d = parseInt(d) < 10 ? ('0' + d) : d;
  let h = date.getHours().toString();
  h = parseInt(h) < 10 ? ('0' + h) : h;
  let m = date.getMinutes().toString();
  m = parseInt(m) < 10 ? ('0' + m) : m;
  let s = date.getSeconds().toString();
  s = parseInt(s) < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d + ' ' + '00' + ':' + '00' + ':' + '00';
}


export {
  axios,
  Toast,
  logout,
  GetRequestParam,
  urlEncode,
  fmtDate,
  checkPhoneNumberNew,
  getRandomInt,
  Dialog,
  cutPhone,
  isiOS,
  Cutsubstr,
  checkResponse,
  showTotalData,
  done,
  cutPhone1,
  fmDate
}
